import axios from 'axios';
import ls from 'local-storage';
import Cryptr from 'cryptr';
import { BASE_URL, SECRET_KEY_ENCRYPT } from '../../utils/config';

// Pop-ups defined in the database (API routes/popups, tables Popup / Popup_Interaction).
// The API finds the user from the JWT: no point of sale needed (menu page).
const cryptr = new Cryptr(SECRET_KEY_ENCRYPT);

const currentCaisse = () => {
  try {
    const c = ls.get('currentcaisse');
    return c ? cryptr.decrypt(c) : null;
  } catch (e) {
    return null;
  }
};

const userHeaders = () => ({ headers: { Authorization: 'Bearer ' + (ls.get('token') || '') } });

// Pop-ups to show on this page, in order: the API applies every rule (dates, conditions, Plus tard…)
export const fetchPopups = (placement) =>
  axios.get(`${BASE_URL}popups`, { ...userHeaders(), params: { placement } }).then((r) => (Array.isArray(r.data && r.data.data) ? r.data.data : []));

export const sendPopupEvent = (id, action) =>
  axios.post(`${BASE_URL}popups/${id}/event`, { action, id_caisse: currentCaisse() }, userHeaders()).catch(() => null);

// « Je souhaite être contacté »: the API emails the team with the account infos (rejects with the API error).
// Time-limited, so the modal never stays on « Envoi en cours… ».
export const sendPopupContact = (id) =>
  axios.post(
    `${BASE_URL}popups/${id}/contact`,
    { id_caisse: currentCaisse(), page: window.location.pathname },
    { ...userHeaders(), timeout: 30000 }
  );

// Language of the page (html lang), French when the pop-up has no text in that language
export const pageLanguage = () => String(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();

export const popupText = (contenu, lang = pageLanguage()) => {
  const c = contenu || {};
  const fr = c.fr || {};
  const own = c[lang] || {};
  const pick = (k) => own[k] || fr[k] || '';
  const points = (own.points && own.points.length ? own.points : fr.points) || [];
  return {
    modele: c.modele || 'standard',
    titre: pick('titre'),
    sous_titre: pick('sous_titre'),
    texte: pick('texte'),
    note: pick('note'),
    points,
    cta: pick('cta'),
    plus_tard: pick('plus_tard'),
    rtl: lang === 'ar' && !!own.titre,
  };
};

// ---------------------------------------------------------------------------- admin (logged-in user)

const adminUrl = (path = '') => `${BASE_URL}popups/admin${path}`;

export const adminApi = {
  meta: () => axios.get(adminUrl('/meta'), userHeaders()).then((r) => r.data),
  list: () => axios.get(adminUrl(), userHeaders()).then((r) => r.data.data || []),
  create: (popup) => axios.post(adminUrl(), popup, userHeaders()).then((r) => r.data),
  update: (id, popup) => axios.put(adminUrl(`/${id}`), popup, userHeaders()).then((r) => r.data),
  ordre: (ids) => axios.put(adminUrl('/ordre'), { ids }, userHeaders()).then((r) => r.data),
  setActif: (id, actif) => axios.patch(adminUrl(`/${id}/actif`), { actif: actif ? 1 : 0 }, userHeaders()).then((r) => r.data),
  reset: (id) => axios.post(adminUrl(`/${id}/reset`), {}, userHeaders()).then((r) => r.data),
  remove: (id) => axios.delete(adminUrl(`/${id}`), userHeaders()).then((r) => r.data),
  upload: (file) => {
    const data = new FormData();
    data.append('image', file);
    return axios.post(adminUrl('/upload'), data, userHeaders()).then((r) => r.data.url);
  },
};

export const errorText = (e, fallback = 'Erreur serveur') =>
  (e && e.response && e.response.data && e.response.data.error) || fallback;
